// ---- Package Contents accordion (unchanged) ----
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('.mr-package-contents').forEach(function(box){
    var toggle = box.querySelector('[data-mr-toggle]');
    var body = box.querySelector('[data-mr-body]');
    if(!toggle || !body) return;
    toggle.addEventListener('click', function(){
      var isOpen = box.classList.toggle('is-open');
      body.style.maxHeight = isOpen ? body.scrollHeight + 'px' : '0';
    });
  });
});

// ---- Mini Ritual: pick any 3, match to real variant ----
document.addEventListener('DOMContentLoaded', function(){
  var root = document.getElementById('MrRitual');
  if(!root) return;

  var variants = JSON.parse(document.getElementById('MrRitualVariants').textContent);
  var optionBtns = Array.prototype.slice.call(root.querySelectorAll('#MrRitualOptions [data-product]'));
  var cta = document.getElementById('MrRitualCta');
  var errorEl = document.getElementById('MrRitualError');
  var counterEl = document.getElementById('MrRitualCounter');

  var chosen = []; // preserves click order, e.g. ['Dry Oil', 'Black Soap', 'Argan Soap']

  function findVariantForChosen(list){
    if(list.length !== 3) return null;
    var sortedChosen = list.slice().sort();
    return variants.filter(function(v){
      var vals = [v.option1, v.option2, v.option3].filter(Boolean).sort();
      if(vals.length !== 3) return false;
      return vals[0] === sortedChosen[0] && vals[1] === sortedChosen[1] && vals[2] === sortedChosen[2];
    })[0] || null;
  }

  function updateUI(){
    counterEl.textContent = '(' + chosen.length + '/3 selected)';
    optionBtns.forEach(function(btn){
      var val = btn.getAttribute('data-product');
      var isChosen = chosen.indexOf(val) !== -1;
      btn.classList.toggle('is-active', isChosen);
      btn.classList.toggle('is-disabled', !isChosen && chosen.length >= 3);
    });
    var v = findVariantForChosen(chosen);
    cta.disabled = !v;
    errorEl.classList.remove('is-visible');
  }

  optionBtns.forEach(function(btn){
    btn.addEventListener('click', function(){
      var val = btn.getAttribute('data-product');
      var idx = chosen.indexOf(val);
      if(idx !== -1){
        chosen.splice(idx, 1); // deselect
      } else {
        if(chosen.length >= 3) return; // already have 3, ignore further clicks
        chosen.push(val);
      }
      updateUI();
    });
  });

  var qtyValueEl = document.getElementById('MrRitualQtyValue');
  var qtyDecreaseBtn = root.querySelector('[data-qty-decrease]');
  var qtyIncreaseBtn = root.querySelector('[data-qty-increase]');

  function getQty(){ return parseInt(qtyValueEl.textContent, 10) || 1; }
  function setQty(val){ if(val < 1) val = 1; qtyValueEl.textContent = val; }

  if(qtyDecreaseBtn){ qtyDecreaseBtn.addEventListener('click', function(){ setQty(getQty() - 1); }); }
  if(qtyIncreaseBtn){ qtyIncreaseBtn.addEventListener('click', function(){ setQty(getQty() + 1); }); }

  cta.addEventListener('click', function(){
    var v = findVariantForChosen(chosen);
    if(!v){
      errorEl.classList.add('is-visible');
      return;
    }

    cta.disabled = true;
    var originalText = cta.textContent;
    cta.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ id: v.id, quantity: getQty() })
    })
    .then(function(res){ return res.json(); })
    .then(function(){ openCartDrawer(); })
    .catch(function(){ window.location.href = '/cart'; })
    .finally(function(){
      cta.disabled = false;
      cta.textContent = originalText;
    });
  });

  function openCartDrawer(){
    var drawer = document.getElementById('MinimogCartDrawer')
      || document.querySelector('m-cart-drawer, cart-drawer, #CartDrawer, [id^="CartDrawer"]');

    if(!drawer){
      window.location.href = '/cart';
      return;
    }

    fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function(res){ return res.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshDrawer = doc.getElementById('MinimogCartDrawer')
          || doc.querySelector('m-cart-drawer, cart-drawer, #CartDrawer, [id^="CartDrawer"]');
        if(freshDrawer){
          drawer.innerHTML = freshDrawer.innerHTML;
        }
      })
      .catch(function(){})
      .finally(function(){
        drawer.classList.add('m-cart-drawer--active');
        if(typeof drawer.open === 'function'){
          drawer.open();
        }
      });
  }
});